// © 2026 Holmes Computer Consultants. All rights reserved.
import { BufferAttribute, BufferGeometry, Mesh, type Object3D } from 'three'
import type asset from '../../SourceArt/PierDisplays/mesh.json'
import type { Finish, PartPalette } from './partsKit'

let data: typeof asset | undefined
export async function prepareAuthoredDisplays(): Promise<void> {
  data ??= (await import('../../SourceArt/PierDisplays/mesh.json')).default
}

/** Attach only an exact fitted frame, relative to the unchanged display plane. */
export function addAuthoredDisplayFrame(machineId: string, width: number, height: number,
  panel: Object3D, palette: PartPalette, geometries: BufferGeometry[]): boolean {
  const fitted=data?.displays.find(d=>d.machineId===machineId)
  if(!fitted||Math.abs(fitted.width-width)>1e-8||Math.abs(fitted.height-height)>1e-8)return false
  for(const part of fitted.parts){
    const geometry=new BufferGeometry()
    geometry.setAttribute('position',new BufferAttribute(new Float32Array(part.positions),3))
    geometry.setAttribute('normal',new BufferAttribute(new Float32Array(part.normals),3))
    geometry.setIndex(part.triangles);geometry.computeBoundingBox();geometry.computeBoundingSphere();geometries.push(geometry)
    const finish=(part.finish[0]!.toLowerCase()+part.finish.slice(1)) as Finish
    const mesh=new Mesh(geometry,palette.get(finish));mesh.name=`display.authored.${part.finish}`;panel.add(mesh)
  }
  return true
}
